import { t } from '@lingui/core/macro';
import { getCookie } from 'utils/cookieHelper';
import styles from '../ApplicationStatusCell.module.css';

export const ManualReview = () => {
  const showDocsFeedback = getCookie('showDocsFeedback') === 'true';

  return (
    <span className={styles.actionableStatus}>
      {showDocsFeedback ? t`Docs in review` : t`Manual check`}
    </span>
  );
};
